import React, { useRef } from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { map } from 'lodash';

import Row from '~/layout/Row';
import Column from '~/layout/Column';

import Button from '~/components/base/Button';
import ButtonGroup from '~/components/base/ButtonGroup';

import { SubTitle } from '~/components/blocks/acf/CtaBar';

import { formElement, input } from '~/styles/forms';
import { srOnly } from '~/styles/helpers';

import { AcfLink } from '~/utilities/propTypes';

const SearchForm = styled.form`
    ${({ theme }) => formElement({ theme })};
    width: 100%;
`;

const Label = styled.label`
    ${srOnly}
`;

const SearchWrapper = styled.div`
    width: 100%;
`;

const SearchInput = styled.input`
    ${({ theme }) =>
        input({ theme, size: 'large', reverse: true, emphasis: true })};
    height: 100% !important;
`;

const CarWashSearch = ({ leftTitle = '', rightTitle = '', ctas = [] }) => {
    const inputRef = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (inputRef.current && inputRef.current.value) {
            navigate('/locations/', {
                state: { searchValue: inputRef.current.value }
            });
        }
    };

    return (
        <Row justify="center">
            <Column
                spanDesktop={4}
                startDesktop={2}
                spanLargeTablet={6}
                startLargeTablet={1}
                span={12}
                start={1}
            >
                {leftTitle ? <SubTitle>{leftTitle}</SubTitle> : null}
                <SearchForm onSubmit={handleSubmit}>
                    <Label htmlFor="car-wash-search">
                        Find Your Car Wash Search
                    </Label>
                    <SearchWrapper>
                        <SearchInput
                            placeholder="City & State or ZIP"
                            name="searchTextLocations"
                            type="text"
                            id="car-wash-search"
                            ref={inputRef}
                        />
                    </SearchWrapper>
                    <Button type="submit">Search</Button>
                </SearchForm>
            </Column>
            <Column
                spanDesktop={4}
                startDesktop={8}
                spanLargeTablet={6}
                startLargeTablet={7}
                span={12}
                start={1}
            >
                {rightTitle ? <SubTitle>{rightTitle}</SubTitle> : null}
                <ButtonGroup links={map(ctas, 'link')} />
            </Column>
        </Row>
    );
};

CarWashSearch.propTypes = {
    leftTitle: PropTypes.string,
    rightTitle: PropTypes.string,
    ctas: PropTypes.arrayOf(
        PropTypes.shape({
            copy: PropTypes.string,
            link: AcfLink
        })
    )
};

export default CarWashSearch;
